import { Outlet } from "react-router-dom";
import { subscribeToMatchData } from "../socketClient";
import { useEffect } from "react";
import Header from "./components/Header/Header";
import Nav from "./components/Nav/Nav";
import MachNav from "./components/Mach-nav/MachNav";
import Footer from "./components/Footer/Footer";

export default function AppLayout() {
  useEffect(() => {
    // Subscribe to all matches for each sport
    subscribeToMatchData({
      eventId: 4, // Cricket
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "cricket",
    });
    subscribeToMatchData({
      eventId: 1, // Soccer (fixed order to match your backend convention)
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "soccer",
    });
    subscribeToMatchData({
      eventId: 2, // Tennis
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "tennis",
    });
  }, []);

  return (
    <div>
      <Header />
      <MachNav />
      <Nav />

      <Outlet />
      <Footer />
    </div>
  );
}
